import {diskAddToCash, getDiskFromCash, getRowsFromCash, rowsAddToCash} from "./DiskService";
import {Disk, rowsOfDisk} from "../disk-list/core/_models";

const CheckMonthDays = (month: number): number | undefined => {
    if (month > 12 || month < 1)
        return undefined;
    if (month < 7)
        return 31;

    return 30
}
const IsLeapYear = (Year: number): boolean => {
    const moment = require('moment-jalaali')
    return moment(`${Year}/12/30`, 'jYYYY/jMM/jDD').isValid()

}
const iterator = (a : any[], n: number) => {
    let current = 0,
        l = a.length;
    return function() {
       const end = current + n;
        let part = a.slice(current,end);
        current =  end < l ? end : 0;
        return part;
    };
};
const uniqueId =()=>{
    // always start with a letter (for DOM friendlyness)
    let idstr=String.fromCharCode(Math.floor((Math.random()*25)+65));
    do {
        // between numbers and characters (48 is 0 and 90 is Z (42-48 = 90)
        let ascicode=Math.floor((Math.random()*42)+48);
        if (ascicode<58 || ascicode>64){
            // exclude all chars between : (58) and @ (64)
            idstr+=String.fromCharCode(ascicode);
        }
    } while (idstr.length<32);

    return Number(idstr);
}
const toEnDigit =(s : any) =>{
    return s.replace(/[\u0660-\u0669\u06f0-\u06f9]/g,    // Detect all Persian/Arabic Digit in range of their Unicode with a global RegEx character set
        function(a :any) { return a.charCodeAt(0) & 0xf }     // Remove the Unicode base(2) range that not match
    )
}
const CalculateBimOffer = (Mashmol : number , PersonCount : number)=> (((Mashmol * 5) / PersonCount) /100) *20
const CalculateDisk = () => {

    const Rows = getRowsFromCash()
    const disk = getDiskFromCash()
    let TBIME = 0, TKOSO = 0, BIC = 0, TTOTL = 0, TMASH = 0, TMAZ = 0, TDD = 0, TMAH = 0, TROOZ = 0, NUM = 0,INC = 0 ,SPOUSE = 0
    for (let i = 0; i < Rows.length; i++) {
        TDD += Rows[i].dsW_DD || 0;
        TROOZ += Rows[i].dsW_ROOZ || 0;
        NUM++;
        TMAH += Rows[i].dsW_MAH || 0;
        TMAZ += Rows[i].dsW_MAZ || 0;
        TMASH += Rows[i].dsW_MASH || 0;
        TTOTL += Rows[i].dsW_TOTL || 0;
        TKOSO += (Rows[i].dsW_MASH || 0) * 0.2;
        BIC +=Rows[i].employeeDto!.isKarfarma ? 0 :  (Rows[i].dsW_MASH || 0) * 0.03;
        TBIME += Rows[i].dsW_BIME || 0;
        INC += (Rows[i].dsW_INC || 0) *( Rows[i].dsW_DD || 0);
        SPOUSE += Rows[i].dsW_SPOUSE || 0

    }

    if(disk.dsK_PRATE === 10 ){
        let mashmol = TMASH ;
        let Count  = NUM ;
        let KarfarmaMash = 0 ;
        const Karmarkar = Rows.filter(p=>p.employeeDto?.isKarfarma === true)

        if( Karmarkar.length > 0){
            for (let k = 0; k < Karmarkar.length ; k++) {
                mashmol -= Karmarkar[k].dsW_MASH || 0 ;
                Count -- ;
                KarfarmaMash += Karmarkar[k].dsW_MASH || 0
            }
        }
        if(Count > 5)
            TKOSO -= CalculateBimOffer(mashmol,Count)
        else if(Count <=5)
            TKOSO = 0
        if(KarfarmaMash > 0 )
            TKOSO += KarfarmaMash * 0.2
    }
    diskAddToCash({
        ...disk, dsK_TBIME: Math.ceil(TBIME), dsK_TKOSO: Math.ceil(TKOSO), dsK_BIC: Math.ceil(BIC), dsK_TTOTL: Math.ceil(TTOTL),
        dsK_TMASH: TMASH, dsK_TMAZ: TMAZ, dsK_TDD: TDD, dsK_TMAH: TMAH, dsK_TROOZ: TROOZ, dsK_NUM: NUM, dsk_INC : INC,dsk_SPOUSE:SPOUSE
    });



}
const CalculateRows=()=>{
    const rows = getRowsFromCash();
    let newRows : rowsOfDisk[]= [] ;
    for (let i = 0; i < rows.length ; i++) {
        if (rows[i]){

            const previous_dsW_TOTL = rows[i].dsW_TOTL || 0 ;
            const dsW_MAH = (rows[i].dsW_ROOZ || 0) * (rows[i].dsW_DD || 0);
            const dsW_MASH = (rows[i].dsW_MAZ || 0) + dsW_MAH + (rows[i].dsW_SPOUSE || 0)+ ((rows[i].dsW_INC || 0) * ((rows[i].dsW_DD || 0)));
            const dsW_ToTal = previous_dsW_TOTL > dsW_MASH ? previous_dsW_TOTL : dsW_MASH ;
            const dsW_BIME = rows[i].employeeDto!.isJanbaz ? 0 : Math.round(dsW_MASH * 0.07) ;
            newRows.push(changeRowValue(dsW_MAH,dsW_MASH,dsW_ToTal,dsW_BIME,rows[i]))
        }
    }
    rowsAddToCash(newRows)
    function changeRowValue(dsW_MAH: number , dsW_MASH : number , dsW_TOTL : number , dsW_BIME : number , row : rowsOfDisk){
        return {
            ...row,
            dsW_MAH,
            dsW_MASH,
            dsW_TOTL,
            dsW_BIME
        }

    }
}
const generateQuery=(queryRequest : {page : number , items_per_page : number , search : string})=>{
    let query = `page=${queryRequest.page}&items_per_page=${queryRequest.items_per_page}`
    if (queryRequest.search.length > 0 ){
        query+=`&search=${queryRequest.search}`
    }
    return query;
}

export {generateQuery,CalculateDisk,toEnDigit,CheckMonthDays,IsLeapYear,iterator,uniqueId,CalculateBimOffer,CalculateRows}